/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {RepeatableUserModelScreensManager} from '../../../../../components/sections/repeatable/repeatable-user-model-screens-manager.service';
import {RepeatableScreensManagerDeps} from '../../../../shared/step/repeatable-screen-manager.class';
import {AbpsBoardService} from '../../../../../domain/model/licenses-certifications/board/abps/abps-board.service';

@Injectable()
export class AbpsBoardScreensManager extends RepeatableUserModelScreensManager {

    constructor(rsmm: RepeatableScreensManagerDeps, protected readonly _modelService: AbpsBoardService) {
        super(rsmm);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/board/abps/abps-board-screens-manager.service.ts